import { motion } from "framer-motion";
import logo from "../../assets/images/logo1.png";

const Footer = () => {
  const isMobile = window.innerWidth < 768;

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const iconStyle = {
    width: 22,
    height: 22,
    fill: "#cbd5e1",
  };

  return (
    <footer
      id="footer"   // ✅ IMPORTANT FOR NAVBAR CONTACT
      style={{
        background: "linear-gradient(180deg, #081728, #050f1d)",
        color: "#cbd5e1",
        padding: "64px 40px 28px",
        overflowX: "hidden",
      }}
    >
      {/* MAIN GRID */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "48px",
        }}
      >
        {/* COMPANY */}
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              marginBottom: "18px",
              flexWrap: "wrap",
            }}
          >
            <img src={logo} alt="MSC Logo" style={{ height: 44 }} />
            <span
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "white",
              }}
            >
              MSC Natraj Logistic Pvt. Ltd.
            </span>
          </div>

          <p style={{ fontSize: "15px", lineHeight: "1.7", opacity: 0.85 }}>
            Enterprise-grade logistics and transportation solutions delivering
            reliability, scale, and operational excellence across India.
          </p>
        </div>

        {/* QUICK LINKS (CONTACT REMOVED ✅) */}
        <div>
          <h4 style={{ color: "white", marginBottom: 18, fontSize: 16 }}>
            Quick Links
          </h4>

          {[
            ["Home", "home"],
            ["Services", "services"],
            ["Features", "features"],
            ["Team", "team"],
          ].map(([label, id]) => (
            <motion.div
              key={id}
              whileHover={!isMobile ? { x: 6, opacity: 1 } : {}}
              whileTap={isMobile ? { scale: 0.96 } : {}}
              transition={{ type: "spring", stiffness: 200, damping: 18 }}
              onClick={() => scrollToSection(id)}
              style={{
                cursor: "pointer",
                marginBottom: 12,
                fontSize: 15,
                opacity: 0.85,
              }}
            >
              {label}
            </motion.div>
          ))}
        </div>

        {/* CONTACT INFO */}
        <div>
          <h4 style={{ color: "white", marginBottom: 18, fontSize: 16 }}>
            Contact Info
          </h4>

          <p style={{ fontSize: 15, marginBottom: 14 }}>
            📞 <strong>+91 9650237131</strong>
          </p>
          <p style={{ fontSize: 15, marginBottom: 14 }}>
            ✉️ <strong>suresh.yadav@mscnatraj.com</strong>
          </p>
          {/* <p style={{ fontSize: 15, marginBottom: 14 }}>
            ✉️ <strong>cs.yadav@mscnatraj.com</strong>
          </p> */}
          <p style={{ fontSize: 15 }}>
            📍 <strong>New Delhi, India</strong>
          </p>
        </div>

        {/* SOCIAL ICONS */}
        <div>
          <h4 style={{ color: "white", marginBottom: 18, fontSize: 16 }}>
            Follow Us
          </h4>

          <div style={{ display: "flex", gap: 20 }}>
            {[
              <svg viewBox="0 0 24 24" style={iconStyle}>
                <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2.5V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.3.2 2.3.2v2.5h-1.3c-1.3 0-1.7.8-1.7 1.6V12h2.9l-.5 2.9h-2.4v7A10 10 0 0 0 22 12z" />
              </svg>,
              <svg viewBox="0 0 24 24" style={iconStyle}>
                <path d="M18.9 2H22l-7.6 8.7L23 22h-6.9l-5.4-7-6.1 7H2l8.1-9.3L1 2h7l4.9 6.4L18.9 2z" />
              </svg>,
              <svg viewBox="0 0 24 24" style={iconStyle}>
                <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
              </svg>,
              <svg viewBox="0 0 24 24" style={iconStyle}>
                <path d="M4 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 6h4v12H4zm6 0h4v2h.1a4.4 4.4 0 0 1 4-2.2c4.3 0 5.1 2.8 5.1 6.4V21h-4v-5.1c0-1.2 0-2.8-1.7-2.8s-2 1.3-2 2.7V21h-4z" />
              </svg>,
            ].map((icon, i) => (
              <motion.div
                key={i}
                whileHover={!isMobile ? { scale: 1.25 } : {}}
                whileTap={isMobile ? { scale: 0.9 } : {}}
                transition={{ type: "spring", stiffness: 300 }}
                style={{ cursor: "pointer", padding: 6 }}
              >
                {icon}
              </motion.div>
            ))}
          </div>

          <p style={{ fontSize: 12, marginTop: 12, opacity: 0.6 }}>
            Social links coming soon
          </p>
        </div>
      </div>

      {/* BOTTOM */}
      <div
        style={{
          borderTop: "1px solid rgba(255,255,255,0.08)",
          marginTop: 44,
          paddingTop: 20,
          textAlign: "center",
          fontSize: 13,
          opacity: 0.7,
        }}
      >
        © {new Date().getFullYear()} MSC Natraj Logistic Pvt. Ltd. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
